"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Toolbar_1 = __importDefault(require("../../Toolbar"));
exports.default = (function (props) {
    return (react_1.default.createElement("div", { className: "emankit__calendar-navigation" },
        react_1.default.createElement(Toolbar_1.default, null, props.children)));
});
//# sourceMappingURL=index.js.map